export default "/_next/static/images/start_with_any_space-4884e9e01727bd2317441c4c1d602fdc.png";